// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-8d3b5e46] .el-card__header{\n  padding:8px 20px;\n  background-color: #eef5fe;\n}\n", ""]);
